import React, { memo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { PropsWithChildren } from "react";
import { cn } from "@onair/utils/cn";
import { Box, Button, FormControlLabel, styled } from "@mui/material";
import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "../../custom-accordion";

import { Typography } from "@mui/material";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface SortableItemProps extends PropsWithChildren {
	id: string;
	header?: React.ReactNode;
	selector?: React.ReactNode;
	label?: React.ReactNode;
}
const SortableItem: React.FC<SortableItemProps> = ({
	id,
	children,
	selector,
	label,
}) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	const [expanded, setExpanded] = React.useState<boolean>(true);

	const handleChange = () => {
		setExpanded((prev) => !prev);
	};

	return (
		<div
			ref={setNodeRef}
			{...attributes}
			style={style}
			className={cn(
				"bg-white border border-transparent rounded-xl overflow-hidden",
				{
					"border-blue-600": isDragging,
				},
			)}
		>
			<Accordion expanded={expanded}>
				<AccordionSummary onToggleExpand={handleChange}>
					<Box component="div" className="flex items-center gap-2 flex-1">
						<DragIndicatorIcon
							{...listeners}
							style={{ cursor: "grab", color: "#1877F2" }}
							aria-label="Drag Handle"
						/>
						<Typography variant="subtitle1">{label}</Typography>
					</Box>
					<Box component="div" className="mr-3">
						{selector}
					</Box>
				</AccordionSummary>
				<AccordionDetails>{children}</AccordionDetails>
			</Accordion>
		</div>
	);
};
export default SortableItem;
